import axios from 'axios';
import config from '../../config';




	const TVseries = {
		async get(contentId) {
			try {
				const apiPath = config.contentApiPath.endsWith('/') ? config.contentApiPath : `${config.contentApiPath}/`;
				let response = await axios.get(`${apiPath}v1/tvseries?restricted=false&seriesTitle=${contentId}`, {});	
				if (response.data && response.data.results.length == 0) {
					response = await axios.get(`${apiPath}v1/tvseries?restricted=false&seriesTitle=${contentId}&showAll=true`, {});
				}
				if (response.data) {
					if (response.data.results && response.data.results.length > 0) {
						response.data.results.sort((a, b) => {
							return a.seasonNumber - b.seasonNumber || a.episodeNumber - b.episodeNumber;
						})
					}
					return response.data;
				}
				throw new Error('TV series not found');
			} catch (error) {
				throw error;
			}
		}
	};

	const Movie = {
		async get(contentId) {
			try {
				const apiPath = config.contentApiPath.endsWith('/') ? config.contentApiPath : `${config.contentApiPath}/`;
				let response = await axios.get(`${apiPath}v1/movie?restricted=false&contentId=${contentId}&showAll=true`, {});
				if (response.data) {
					return response.data;
				}
				throw new Error('TV series not found');
			} catch (error) {
				throw error;
			}
		}
	};

	const Songs = {
		async get(contentId) {
			try {
				const apiPath = config.contentApiPath.endsWith('/') ? config.contentApiPath : `${config.contentApiPath}/`;
				let response = await axios.get(`${apiPath}v1/song?id=${contentId}`, {});
				if (response.data) {
					return response.data;
				}
				throw new Error('Songs not found');
			} catch (error) {
				throw error;
			}
		}
	};

	const ContentImage = {
		async getPortrait(contentId,contentType) {
			try {
				const normalizedType = contentType.toLowerCase();
				const response = await (normalizedType === "tvseries" 
				? TVseries.get(contentId)
				: normalizedType === "songs" || normalizedType === "song"
					? Songs.get(contentId)
					: Movie.get(contentId));
				if (response && response.results.length > 0) {
					return response.results[0].imagePortrait480 || response.results[0].imageLandscape480 || response.results[0].cover_portrait;
				}
				throw new Error('Content not found');
			} catch (error) {
				throw error;
			}
		}
	};

export { TVseries, Movie, Songs, ContentImage};
